import "toastr/build/toastr.min.css";
import { toast } from "react-toastify";
import { REPORT } from "../config/apiEndPoint";
import { POST } from "config/api.config";

/** POST `Report/rtr-internal/filter` */
export const submitRtrInternalReportFilterData = async (data = {}) => {
  try {
    const response = await POST(REPORT.RTR_INTERNAL_FILTER, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `Report/rtr-internal/schedule` */
export const submitRtrInternalReportScheduleData = async (data = {}) => {
  try {
    const response = await POST(REPORT.RTR_INTERNAL_SCHEDULE, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};
